import moduleConfig from './module-config';
import netsRingtones from './nets-ringtones';

export default angular
  .module('app.settings-ringtones', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsRingtones', netsRingtones);
